
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[material]/products",
      function () {
        return require("private-next-pages/[material]/products.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[material]/products"])
      });
    }
  